import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';

export const useInternalAdmin = () => {
  const { userInfo } = useInitialInfoStore();
  return userInfo?.role === 'Admin' && userInfo?.username?.endsWith('@conviva.com');
};
